import { FormikProvider, useFormik } from 'formik';
import { useEffect } from 'react';

import Card from '@perpay-web/components/base/Card/Card';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Modal from '@perpay-web/components/base/Modal/Modal';
import NonFieldErrors from '@perpay-web/components/base/NonFieldErrors/NonFieldErrors';
import warningIcon from '@perpay-web/fintech/assets/images/warningIcon.png';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import { ssiAcknowledgementSchema } from '@perpay-web/fintech/validators/formBased';
import FormikCheckbox from '@perpay-web/storefront/components/base/Checkbox/FormikCheckbox';
import { noop } from '@perpay-web/utils/noop';
import { validateForm } from '@perpay-web/validators/formBased';

import styles from './CardApplicationSSIModal.scss';

const CardApplicationSSIModal = ({
    onChangeEmployer = noop,
    onContinue = noop,
    onMount = noop,
}) => {
    const formik = useFormik({
        initialValues: {
            ssiAcknowledgement: false,
        },
        onSubmit: (values) => {
            onContinue(values);
        },
        validate: (values) => validateForm(values, ssiAcknowledgementSchema),
    });

    useEffect(() => {
        onMount();
    }, [onMount]);

    const handleChangeEmployer = () => {
        onChangeEmployer();
    };

    const handleContinue = () => {
        formik.handleSubmit();
    };

    return (
        <FormikProvider value={formik}>
            <Modal
                showClose={false}
                containerClassName={styles['modal-container']}
            >
                <div>
                    <img
                        src={warningIcon}
                        className={styles['warning-icon-image']}
                        alt='warning icon'
                    />
                </div>
                <div className={styles.title}>
                    Your benefits do not allow you to split your direct deposit.
                </div>

                <div className={styles['modal-copy']}>
                    Perpay is designed for you to send just a portion of your
                    paycheck. Unfortunately, your benefits do not allow deposits
                    to be split to multiple accounts. If approved, you&apos;ll
                    need to direct your full benefit amount to your Perpay
                    Account.
                </div>
                <div className={styles['modal-copy']}>
                    Once received, only your minimum direct deposit requirement
                    will be applied to your Perpay account. The remainder will
                    be sent to your linked bank account.
                </div>
                <div className={styles['checkbox-error-container']}>
                    <Card className={styles['checkbox-container']}>
                        <FormikCheckbox
                            name='ssiAcknowledgement'
                            label='By checking this box, I acknowledge I have read and understand the above.'
                        />
                    </Card>
                    {formik.errors.ssiAcknowledgement &&
                    (formik.touched.ssiAcknowledgement ||
                        formik.submitCount > 0) ? (
                        <NonFieldErrors
                            errors={{
                                message: [formik.errors.ssiAcknowledgement],
                            }}
                            className={styles.error}
                        />
                    ) : null}
                </div>

                <div className={styles['button-container']}>
                    <CardCta
                        Component={CustomButton}
                        mode='dark'
                        type='button'
                        onClick={handleContinue}
                    >
                        Continue
                    </CardCta>
                    <CustomButton
                        action='tertiary'
                        size='medium'
                        onClick={handleChangeEmployer}
                        className={styles['change-employer']}
                        type='button'
                    >
                        Change Employer
                    </CustomButton>
                </div>
            </Modal>
        </FormikProvider>
    );
};

export default CardApplicationSSIModal;
